import styled from "styled-components";

export const ExpandIcon = styled.img`
  width: 30px;
  height: 20px;
  position: absolute;
  bottom : 0;
  right : -30px ;
`;

export const MobileVisibleDiv = styled.div`
  display: none;
  @media screen and (max-width : 768px){
    display: flex;
  }
`

export const MobileHiddenDiv = styled.div`
  display: flex;
  @media screen and (max-width: 768px) {
    display: none;
  }
`;



